import { Profile } from 'store/slices/profileSlice';
import { BackendApiProfile } from 'types';

export const mapBackendProfileToFrontend = (profile: BackendApiProfile): Profile => ({
  id: profile._id,
  name: profile.name,
  avatar: profile.avatar,
  isOwner: !!profile.owner,
  isKid: !!profile.kids,
  ageRating: profile.rating,
  userId: profile.user,
  wasAccountDeactivated: profile.wasAccountDeactivated === true,
});

export const mapFrontendProfileToBackend = (profile: Profile): Partial<BackendApiProfile> => ({
  name: profile.name,
  rating: profile.ageRating,
  kids: profile.isKid,
  owner: profile.isOwner,
  user: profile.userId,
});
